type Gtag = (...args: any[]) => void;

declare global {
    interface Window {
        dataLayer: any[];
        gtag?: Gtag;
    }
}

function initGA(measurementId?: string) {
    if (!measurementId || document.getElementById('ga4-script')) {
        return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.id = 'ga4-script';
    document.head.appendChild(script);

    const inline = document.createElement('script');
    inline.id = 'ga4-inline';
    inline.innerHTML = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${measurementId}', { send_page_view: true });`;
    document.head.appendChild(inline);
}

function event(name: string, props?: Record<string, any>) {
    if (typeof window.gtag !== 'function') {
        return;
    }
    window.gtag('event', name, props || {});
}

const googleAnalytics = {
    initGA,
    event,
};

export default googleAnalytics;
